import { useQuery } from '@tanstack/react-query';
import BackendClient from '@/api/backendClient.ts';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';
import { UserContext } from '@/models/UserContext';

const useUserContext = (chatId: string | null | undefined) => {
  const queryKey = ['user_context', chatId];

  const queryFn = async () => {
    return getContext(chatId!);
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!chatId,
    staleTime: 1000 * 60 * 5,
  });
};

export default useUserContext;

async function getContext(chatId: string): Promise<UserContext> {
  try {
    const response = await BackendClient.get<BackendSuccessResponse<UserContext>>('/api/chat/context', {
      params: { chat_id: chatId },
    });

    return response.data.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while fetching user context.');
  }
}
